import { Route, Redirect } from 'react-router-dom';
import cookie from './services/cookie/index.js';

const PrivateDocRoute = ({ component: Component, ...rest }) => {
  const username = cookie().get("username");
  const token = cookie().get("tokenDoc");
  const role = cookie().get("role");

  const isAuthenticated = token && username && role;

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to="/doctor" />
        )
      }
    />
  );
};

export default PrivateDocRoute;
